import { Card, PillButton, Stack, Text } from 'library/ui';
import { Colors } from 'library';
import { styled } from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import React, { useState } from 'react';
import { ShiftProviderUser } from 'models';
import VpkApplicationModal from './VpkApplicationModal';
import ClearinghouseModal from './ClearinghouseModal';

interface ChecklistItem {
    key: string;
    label: string;
    onAdd: () => void;
}

export default function CenterActionChecklist({
    needs_center_action,
    provider_user,
    business_location_id,
    refresh,
}: {
    needs_center_action: string[];
    provider_user: ShiftProviderUser;
    business_location_id: number;
    refresh: () => void;
}) {
    const [vpkModalOpen, setVpkModalOpen] = useState(false);
    const [clearinghouseModalOpen, setClearinghouseModalOpen] = useState(false);
    const items: ChecklistItem[] = [];

    if (needs_center_action.includes('add_to_clearinghouse')) {
        items.push({
            key: 'add_to_clearinghouse',
            label: 'Add to Clearinghouse',
            onAdd: () => setClearinghouseModalOpen(true),
        });
    }

    if (needs_center_action.includes('add_to_vpk')) {
        items.push({
            key: 'add_to_vpk',
            label: 'Add to VPK Roster',
            onAdd: () => setVpkModalOpen(true),
        });
    }

    if (!items.length) return null;

    return (
        <Stack gap="sm">
            <Text size="xs" weight="bold" tone="secondary">
                ACTION REQUIRED
            </Text>
            <Card padding="xs">
                <Stack gap="sm">
                    {items.map((item) => (
                        <ItemRow key={item.key}>
                            <LabelGroup>
                                <RadioButtonUncheckedIcon
                                    htmlColor={Colors.accent}
                                    fontSize="small"
                                    style={{ flexShrink: 0 }}
                                />
                                <Text size="sm" weight="semibold">
                                    {item.label}
                                </Text>
                            </LabelGroup>
                            <CompactPillWrap>
                                <PillButton variant="secondary" onClick={item.onAdd}>
                                    Add
                                </PillButton>
                            </CompactPillWrap>
                        </ItemRow>
                    ))}
                </Stack>
            </Card>
            {vpkModalOpen && (
                <VpkApplicationModal
                    provider_user={provider_user}
                    business_location_id={business_location_id}
                    refresh={refresh}
                    onClose={() => setVpkModalOpen(false)}
                />
            )}
            {clearinghouseModalOpen && (
                <ClearinghouseModal
                    provider_user={provider_user}
                    business_location_id={business_location_id}
                    refresh={refresh}
                    onClose={() => setClearinghouseModalOpen(false)}
                />
            )}
        </Stack>
    );
}

const ItemRow = styled('div')({
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    marginLeft: -4,
});

const LabelGroup = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    flex: '1 1 auto',
});

const CompactPillWrap = styled('div')({
    display: 'flex',
    flexShrink: 0,
    '& > button': {
        padding: '6px 16px',
    },
});
